<template>
  <div>
    <DAppRankNew :show-search-box="true"></DAppRankNew>
  </div>
</template>

<script>

  import DAppRankNew from '../widgets/DAppRankNew'

  export default {
    name: 'search',
    components: {DAppRankNew},
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/search.vue